// MobileHomePage.js - With service selection functionality
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Shield, Sparkles, Clock, ChevronDown, MapPin } from 'lucide-react';
import main from './images/main10.png';
import ServicesComponent from './ServicesComponent';

const MobileHomePage = () => {
  const [selectedService, setSelectedService] = useState(null);
  const navigate = useNavigate();

  // Handle service selection from the ServicesComponent
  const handleSelectService = (serviceData) => {
    setSelectedService(serviceData);
    
    // If a service is selected (not just a category change)
    if (serviceData.type === 'service') {
      // You can either navigate to booking page with the selected service
      navigate('/book', { 
        state: { 
          selectedService: serviceData 
        }
      });
      
      // Or you could store the selection in localStorage for persistence
      localStorage.setItem('selectedService', JSON.stringify(serviceData));
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Mobile-specific hero section with adjusted image positioning */}
      <section className="relative h-[100svh] overflow-hidden">
        {/* Background image - mobile optimized view */}
        <div className="absolute inset-0">
          <img
            src={main}
            alt="Car detailing"
            className="w-full h-full object-cover object-[65%_center]"
            // The 65% horizontal positioning shows more of the right side where the detailer is
          />
          {/* Enhanced gradient overlay for better text contrast on mobile */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/30 to-transparent"></div>
        </div>
        
        {/* Subtle glow effect */}
        <div className="absolute top-1/4 left-0 w-1/2 h-1/2 bg-blue-500/5 blur-3xl rounded-full"></div>
        
        {/* Serving Chicagoland text at top middle */}
        <div className="absolute top-40 left-0 right-0 flex justify-center">
          <div className="inline-flex items-center py-1 px-3 rounded-full bg-white/10 backdrop-blur-md border border-white/20">
            <MapPin className="h-3 w-3 text-cyan-400 mr-1" />
            <span className="text-white/90 text-xs font-medium">Serving Throughout Chicagoland</span>
          </div>
        </div>
        
        {/* Mobile-optimized content container - MOVED TO BOTTOM */}
        <div className="absolute bottom-11 left-0 right-0 px-4">
          {/* Smaller, more compact blur text section */}
          <div className="backdrop-blur-md bg-black/30 border border-white/10 p-4 rounded-xl max-w-full mx-auto">
            <h1 className="text-2xl font-bold text-white mb-2 tracking-tight">
              <span className="bg-gradient-to-r from-cyan-300 to-blue-500 bg-clip-text text-transparent">JP Premium</span> Mobile
              Detailing
            </h1>
            
            {/* More compact feature icons */}
            <div className="flex flex-wrap gap-2 mb-3">
              <div className="flex items-center gap-1 text-white/90">
                <Shield className="h-3 w-3 text-cyan-400" />
                <span className="text-xs">Premium Protection</span>
              </div>
              <div className="flex items-center gap-1 text-white/90">
                <Sparkles className="h-3 w-3 text-yellow-400" />
                <span className="text-xs">Professional Results</span>
              </div>
            </div>
            
            {/* Smaller CTA buttons */}
            <div className="flex gap-2">
              <Link to="/estimate" className="flex-1">
                <button className="w-full bg-white/10 backdrop-blur-sm border border-white/20 text-white px-3 py-2 rounded-lg font-medium text-xs">
                  GET ESTIMATE
                </button>
              </Link>
              
              <Link to="/services" className="flex-1">
                <button className="w-full bg-gradient-to-r from-blue-500 to-cyan-400 text-white px-3 py-2 rounded-lg font-medium text-xs">
                  SERVICES
                </button>
              </Link>
            </div>
          </div>
        </div>
        
        {/* Mobile-optimized scroll indicator - repositioned to make sure it's visible */}
        <div className="absolute bottom-4 right-4 z-10">
          <div className="flex items-center gap-1 text-white/90">
            <span className="text-xs tracking-widest">SCROLL</span>
            <ChevronDown className="w-4 h-4 animate-bounce" />
          </div>
        </div>
      </section>
      
      {/* Pass the onSelectService prop to the ServicesComponent */}
      <ServicesComponent onSelectService={handleSelectService} />
    </div>
  );
};

export default MobileHomePage;